var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350,0C156.8,0,0,156.8,0,350s156.8,350,350,350s350-156.8,350-350C700,156.8,543.2,0,350,0L350,0z M350,627.9 C196.7,627.9,72.1,503.3,72.1,350C72.1,196.7,196.7,72.1,350,72.1c153.3,0,277.9,124.6,277.9,277.9 C627.9,503.3,503.3,627.9,350,627.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,252c0,24.7-20.1,44.8-44.8,44.8s-44.8-20.1-44.8-44.8s20.1-44.8,44.8-44.8S309.4,227.3,309.4,252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.3,252c0,24.7-20.1,44.8-44.8,44.8s-44.8-20.1-44.8-44.8s20.1-44.8,44.8-44.8S482.3,227.3,482.3,252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,492.1c32.9-18.2,72.8-29.4,116.2-29.4c43.4,0,84,10.5,116.2,28.7c14,7.7,32.9,5.6,43.4-4.9 c10.5-10.5,7-25.2-6.3-32.9c-42.7-23.8-95.9-38.5-153.3-38.5c-57.4,0-110.6,14.7-153.3,38.5c-14,7.7-16.8,22.4-6.3,32.9 C200.2,497.7,219.8,499.8,233.1,492.1L233.1,492.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoor);
export default __webpack_public_path__ + "static/media/poor.c6546b3a2054037ad7cb65dbc999a0e1.svg";
export { ForwardRef as ReactComponent };